import template from './App.html';
import win from './lib/win';
import storage from './lib/storage';

import './components';

export default {
	name: 'App',
	template,
	data: () => ({
		ready: false,

		theme: null,

		defaultUrl: '/dashboard',

		query: {},
		params: {},
		hash: null,
		routeName: null,

		user: undefined,
		sidebarShown: (win.width >= win.LG && parseInt(localStorage.getItem('idu'))),
		quickFiltersShown: !!storage.get('quickFilters'),
		dialogShown: false,
		dialogData: {},

		segments: null,

		defQuery: null,

		authPopup: {
			shown: false
		},
		authPopupHeadersMap: {
			login: 'TO_LOGIN',
			register: 'TO_REGISTER',
			forgot: 'RESTORE_ACCOUNT',
		},

		tz: null,
		owner: null,

		lang: null,
		languages: null,
		langLoading: false,
		loadedLang: null,
		loadedLangs: [],
		langMessages: {},

		isLoading: false,

		onModalClose: null,

		backButtonFns: [],

		domains: null,
		distinctValues: {
			os: null,
			browser: null,
			vendor: null,
			device: null,
			referrer: null,
			screen: null
		},

		worldMap: null
	}),
	props: {
		source: String
	},
	computed: {
		appClasses() {
			return {
				'with-sidebar': this.sidebarShown,
				'no-sidebar': !this.sidebarShown,
				'app-loading': this.isLoading,
				'quick-filters-shown': this.withQuickFilters && this.quickFiltersShown
			};
		},
		idu() {
			return this.user ? this.user.id : 0;
		},
		isMob() {
			return this.win.width < this.win.LG;
		},
		page() {
			return this.$route.path.split('/').slice(2).join('/');
		},
		onlyContent() {
			return (this.routeName === 'recording' || this.routeName === 'home');
		},
		withQuickFilters() {
			return ['dashboard', 'summary', 'slices', 'pageviews', 'sessions', 'heatmap'].indexOf(this.$route.name) !== -1;
		},
		queryJson() {
			let q = {...this.app.query};
			delete q.dates;

			return this.json.encode(q);
		},
		canSetDefault() {
			return (this.queryJson !== this.json.encode(this.defQuery));
		}
	},
	methods: {
		setTz(tz) {
			this.tz = tz;
			this.cookie.set('tz', tz);
		},
		initTz() {
			let tz = this.cookie.get('tz');
			if (!tz) {
				tz = moment.tz.guess();
				if (tz) {
					this.cookie.set('tz', tz);
				}
			}
			this.tz = tz || 'UTC';
		},
		setOwner(owner) {
			this.owner = owner;
			if (owner) {
				this.cookie.set('owner', owner);
			} else {
				this.cookie.remove('owner');
			}
		},
		initOwner() {
			this.owner = parseInt(this.cookie.get('owner')) || null;
		},
		navigate(route, isReplace = false) {
			let method = isReplace ? 'replace' : 'push';
			this.$router[method](route).catch(err => {
				if (err) throw err;
			});
		},
		resolveDialog(val) {
			if (val === undefined) {
				val = this.dialogData.cancelVal;
			}
			this.dialogData.resolve(val);
			this.dialogShown = false;
		},
		showAuthPopup(type = 'login') {
			this.authPopup.shown = true;
			this.authPopup.type = type;
		},
		async initUser() {
			await this.refreshUser();
			window.addEventListener('storage', e => {
				if (e.key === 'idu') {
					this.refreshUser();
				}
			});
		},
		async refreshUser() {
			this.user = await this.http.get('Auth.getMe');

			if (this.user) {
				this.sidebarShown = !this.isMob;

				let url = this.app.query.return;
				if (url) {
					this.navigate('/' + url);
				}

				localStorage.setItem('idu', this.user.id || this.user.guestId);
				this.loadSegments();
			} else {
				this.sidebarShown = false;
				localStorage.removeItem('idu');
				this.segments = [];
			}
		},
		async logout() {
			await this.http.post('Auth.logout');
			await this.refreshUser();

			this.owner = null;
			this.cookie.remove('owner');
		},
		async onAuth() {
			this.authPopup.shown = false;
			await this.refreshUser();
		},
		async loadSegments() {
			this.segments = await this.http.get('Auth.getSegments');
		},
		requireAuth() {
			if (!this.user) {
				let url = location.pathname.slice(1) + location.search + location.hash;
				this.navigate('/auth?return=' + this.url.encode(url));
			}
		},
		toggleSidebar(source) {
			this.sidebarShown = !this.sidebarShown;

			if (!this.isMob) return;

			if (this.sidebarShown) {
				this.backButtonPush(() => {
					this.sidebarShown = false;
				});
			} else {
				this.backButtonPop();
			}
		},
		async initLang() {
			this.lang = this.cookie.get('lang') || 'en';
			this.loadAvailableLanguages();
			this.loadLangMessages();
		},
		async loadAvailableLanguages() {
			this.languages = await this.http.get('I18n.getLanguages');
		},
		getLangGeo() {
			if (!this.languages) return null;
			let lang = this.languages.find(l => l.key === this.lang);
			return lang && lang.geo;
		},
		chooseLang(lang) {
			this.lang = lang;
			this.cookie.set('lang', lang, 365 * 86400);
			this.loadLangMessages();
		},
		async loadLangMessages() {
			let lang = this.lang;

			let langs = [];
			if (this.loadedLangs.indexOf(lang) === -1) {
				langs.push(lang);
			}
			if (lang !== 'en' && this.loadedLangs.indexOf('en') === -1) {
				langs.push('en');
			}

			if (langs.length) {
				this.langLoading = true;
				let res = await this.http.get('I18n.getMessages', langs);
				for (let key in res) {
					this.langMessages[key] = res[key];
					this.loadedLangs.push(key);
				}
				this.langLoading = false;
			}

			this.loadedLang = lang;
		},
		initWin() {
			this.win.onResize(e => {
				if (e.oldWidth >= this.win.LG && e.width < this.win.LG) {
					this.sidebarShown = false;
				} else if (e.oldWidth < this.win.LG && e.width >= this.win.LG) {
					this.sidebarShown = true;
				}
			});
		},
		async initStore() {
			this.store.init({
				domains: () => this.http.get('Site.getDomains'),
				distinctValues: () => this.http.get('Stats.getDistinctValues')
			});
		},
		backButtonPush(fn) {
			let frame = document.querySelector('#history-frame');
			frame.contentWindow.postMessage({semaltPushState: true}, location.origin);
			this.backButtonFns.push(fn);
		},
		backButtonPop() {
			let fns = this.backButtonFns;
			fns[fns.length - 1] = null;

			history.back();
		},
		initHistoryFrame() {
			window.addEventListener('message', e => {
				if (e.data.semaltPopState && this.backButtonFns && this.backButtonFns.length) {
					let fn = this.backButtonFns.pop();
					fn && fn();
				}
			});
		},
		initTheme() {
			if (this.app.query.theme) {
				this.storage.set('theme', this.app.query.theme);
			}

			let theme = this.storage.get('theme');
			this.setTheme(theme);
		},
		setTheme(theme) {
			if (theme === 'null') {
				theme = null;
			}

			this.storage.set('theme', theme);
			this.theme = theme || 'modern';

			document.body.setAttribute('data-theme', this.theme);
		},
		async loadDomains() {
			this.domains = await this.store.get('domains');
		},
		getAvailableDomains() {
			if (!this.domains) return [];

			return this.domains[this.owner || 0] || [];
		},
		async loadDistinctValues() {
			let res = await this.store.get('distinctValues');
			for (let key in this.distinctValues) {
				if (this.distinctValues.hasOwnProperty(key)) {
					this.distinctValues[key] = res.values[key] || [];
				}
			}
		},
		getContentWidth() {
			return this.$refs.content.getBoundingClientRect().width;
		},
		refreshRoute(to, from) {
			this.query = { ...this.$route.query };
			this.params = { ...this.$route.params };
			this.hash = this.$route.hash;
			this.routeName = this.$route.name;

			this.defQuery = this.json.decode(this.getDefaultQuery()) || {};

			this.fixRoute(to, from);
		},
		fixRoute(to, from) {
			let newQuery = {};

			if (!from || to.name !== from.name) {
				let paramsCnt = Object.keys(to.query).length;
				if (!paramsCnt && this.defQuery) {
					newQuery = this.defQuery;
				}
			}

			let domain = this.app.query.domain;
			if (domain && domain.indexOf('sub_') === 0) {
				newQuery.domain = domain.slice(4);
			}

			if (to.query.dates && /^\d\d\d\d-\d\d-01_\d\d\d\d-\d\d-[23]\d$/.test(to.query.dates)) {
				let [fromDate, toDate] = to.query.dates.split('_');
				if (fromDate.slice(0, 7) === toDate.slice(0, 7)) {
					let days = moment.tz(toDate, this.tz).daysInMonth();
					if (parseInt(toDate.slice(-2)) === days) {
						newQuery.dates = fromDate.slice(0, 7);
					}
				}
			}

			if (Object.keys(newQuery).length) {
				this.editQueryParams(newQuery, true);
			}
		},
		getDefaultQuery() {
			return window.localStorage && localStorage.getItem('def_query');
		},
		setDefaultQuery() {
			if (!window.localStorage) return;

			if (this.queryJson) {
				localStorage.setItem('def_query', this.queryJson);
			} else {
				localStorage.removeItem('def_query');
			}
			this.defQuery = this.json.decode(this.queryJson);
		}
	},
	watch: {
		$route(to, from) {
			statInside('hit');

			this.refreshRoute(to, from);

			if (this.sidebarShown && this.isMob) {
				this.sidebarShown = false;
			}
		},
		lang() {
			let dir = (['ar', 'he', 'ur', 'fa'].indexOf(this.lang) === -1 ? 'ltr' : 'rtl');

			document.documentElement.setAttribute('lang', this.lang);
			document.documentElement.setAttribute('dir', dir);

			let locale = this.lang;
			if (locale === 'zh') {
				locale = 'zh-CN';
			}
			moment.locale(locale);
		},
		quickFiltersShown() {
			if (this.quickFiltersShown) {
				this.storage.set('quickFilters', 1);
			} else {
				this.storage.remove('quickFilters');
			}
		}
	},
	async created() {
		this.initStore();
		this.refreshRoute(this.$route);
		this.initTz();
		this.initOwner();
		this.initWin();
		await this.initLang();
		await this.initUser();

		this.events.on('auth', this.onAuth);

		this.ready = true;
	},
	async mounted() {
		this.initHistoryFrame();
		this.initTheme();
	}
}